export default {
  code: 'b6e48fe2',
  showReminderModal: true,
  showHeaderSlider: true,
  showEventSlider: true,
  sportsBook: true,
  useDWH: true,
  useMirrors: true,
  api: {
    transactions: '/paygate/order/list/',
  },
  app: {
    useToken: true,
    links: {
      ios: 'https://olympcasinoapp.top/ios/',
      android: 'https://olympcas.onelink.me/bJv7/',
      default: 'https://olympcas.onelink.me/TAVa/mainsite',
    },
    deepLinks: {
      default: 'default',
      platforms: ['android', 'default'],
    },
  },
  headerSize: {
    desktop: 88,
    mobile: 88,
  },
  auth: {
    defaultTab: 'phone',
    socialStyle: {},
    tabs: ['phone', 'email'],
    apiMethod: 'REST',
  },
  typeOfTransactions: 1,
  paymentText: '',
  authBySession: false,
  cashback: {
    variablesContent: {
      type: 'fast_cashback',
      title: process.env.ENVIRONMENT === 'production' ? 'Olymp.casino' : 'Olymp',
    },
  },
  footer: {
    licenseText: `
      <div class='footer-anj__text'>
        <a href='https://olymp.casino' target='_blank'>olymp.casino</a> is operated by Bislot N.V. registered under No.157228 at Abraham de Veerstraat 9, Curaçao. This website is licensed and regulated of the Gaming Board of Anjouan at Mutsamudu., license No. ALSI-032401023-FI3. Payments are processed by Factdata Ltd, Dept 4869a 196 High Road, Wood Green, London, England, N22 8HH (Registration number 13527363 ) acting as an agent on behalf of Bislot N.V.
      </div>`,
  },
  groupRootPath: 'casino',
  seo: {
    hostName: [
      {
        domain: 'olymp-casinobd.com',
        langMap: {
          bn: 'bn',
          'en-bd': null,
        },
      },
      // {
      //   domain: 'olymp-casinoky.com',
      //   langMap: {
      //     'ky-kg': 'ky-kg',
      //   },
      // },
      // {
      //   domain: 'olymp-casinouz.com',
      //   langMap: {
      //     'uz-uz': 'uz-uz',
      //   },
      // },
    ],
  },
  games: {
    iframe: new Set([
      'bg',
      'spribe',
      'jetgames',
      'betsolutions',
      'hollywoodtv',
      'goldenrace',
      'turbogames',
      'superlottotv',
      'sgtv',
      'avx',
      'liw',
      'agt',
      'inbetgames',
    ]),
  },
  regPlatform: null,
  socialLinks: {
    default: {
      FACEBOOK: 'https://www.facebook.com/olymp6casino',
      INSTAGRAM: 'https://instagram.com/olymp_casino?igshid=MzRlODBiNWFlZA==',
      INSTAGRAM_WORLD: 'https://www.instagram.com/olympcasino_global/',
      TG_BOTS: '@olymp_casino_bot|https://t.me/olymp_casino_bot||@olymp_casino|https://t.me/olymp_casino',
    },
    region: {
      az: {
        FACEBOOK: 'https://www.facebook.com/olympcasinoaz',
        INSTAGRAM: 'https://instagram.com/olymp_casino_azerbaijan?igshid=MzRlODBiNWFlZA==_azerbaijan',
        INSTAGRAM_WORLD: 'https://www.instagram.com/olympcasino_global/',
        TG_BOTS: '@olymp_casino_bot|https://t.me/olymp_casino_bot||@olymp_casino|https://t.me/olymp_casino_az',
      },
      bd: {
        FACEBOOK: 'https://www.facebook.com/olympcas1no',
        INSTAGRAM: 'https://instagram.com/olymp_casino?igshid=MzRlODBiNWFlZA==',
        INSTAGRAM_WORLD: 'https://www.instagram.com/olympcasino_global/',
        TG_BOTS: '@olymp_casino_bot|https://t.me/olymp_casino_bot||@olymp_casino|https://t.me/olymp_casino_bd',
      },
    },
  },
}
